const Title = ({ text }: { text: string }) => {
  return <div className='font-[DKLiquidEmbrace] text-grey800 md:text-[32px] text-[24px]'>{text}</div>;
};

export default Title;
